import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateLinkMerchantsMutation = agentId => {
	const dispatch = useDispatch();

	return useMutation(
		(values: any) => {
			dispatch(uiActions.showSpinnerOverlay());
			const merchantAgents = values?.merchantAgents?.map(({ id }) => ({
				merchantId: id,
			}));

			return merchantsService.updateMerchantUserLinks({
				agentId,
				links: {
					...values,
					merchantAgents,
				},
			});
		},
		{
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Merchant User links successfully updated",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateLinkMerchantsMutation;
